export default {
  presets: [
    {
      label: 'Fade-In',
      key: 'fadein',
      properties: [{ prop: 'opacity', value: 0 }],
    },

    {
      label: 'Slide From Top',
      key: 'fadeinslidedown',
      properties: [
        { prop: 'opacity', value: 0 },
        { prop: 'y', value: -50 },
        { prop: 'rotation', value: 15, ease: 'Elastic.easeInOut' },
      ],
    },

    {
      label: 'Slide From Bottom',
      key: 'fadeinslideup',
      properties: [
        { prop: 'opacity', value: 0 },
        { prop: 'y', value: 50 },
        { prop: 'rotation', value: 15, ease: 'Elastic.easeInOut' },
      ],
    },

    {
      label: 'Slide From Left',
      key: 'fadeinslideleft',
      properties: [{ prop: 'opacity', value: 0 }, { prop: 'x', value: -50 }],
    },

    {
      label: 'Slide From Right',
      key: 'fadeinslideright',
      properties: [{ prop: 'opacity', value: 0 }, { prop: 'x', value: 50 }],
    },

    {
      label: 'Zoom-In + Fade-In',
      key: 'zoominfadein',
      properties: [{ prop: 'opacity', value: 0 }, { prop: 'scale', value: 0 }],
    },

    {
      label: 'Zoom-Out + Fade-In',
      key: 'zoomoutfadein',
      properties: [
        { prop: 'opacity', value: 0 },
        { prop: 'scale', value: 2, ease: 'Elastic.easeInOut' },
        { prop: 'rotation', value: 30 },
      ],
    },

    { label: '[Empty]', key: 'empty', properties: [] },
  ],
  properties: [
    { prop: 'x', label: 'X', value: 0, open: false },
    { prop: 'y', label: 'Y', value: 0, open: false },
    { prop: 'scale', label: 'Scale', value: 1, open: false },
    { prop: 'rotation', label: 'Rotation', value: 0, open: false },
    { prop: 'autoAlpha', label: 'Opacity', value: 1, open: false },
  ],
  functions: [{ name: 'random', func: () => Math.random() }],
};



// WEBPACK FOOTER //
// ./src/store/modules/transitions.js